import React from 'react';
import styled from 'styled-components';
import { CarvanaWindow, isCarvanaNativeApp, sendNativeMessage, NativeMessageEvent } from '@carvana/core-native-messaging';

type BaseAnchorProps = React.ComponentProps<'a'>;

export interface NativeLinkProps extends Omit<BaseAnchorProps, 'ref'> {
  type?: 'internal' | 'external';
}

const StyledAnchor = styled.a`
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const NativeLink = React.forwardRef<HTMLAnchorElement, NativeLinkProps>(({
  href = '',
  type = 'internal',
  onClick,
  children,
  ...props
}, ref) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();

    // Allow custom onClick handler to execute first
    if (onClick) {
      onClick(event);
    }

    if (isCarvanaNativeApp()) {
      if (type === 'external') {
        sendNativeMessage(NativeMessageEvent.LINK, {
          url: href,
          linkType: 'browser'
        });
      } else {
        CarvanaWindow.location.href = href;
      }
    } else {
      // In non-native context, use regular navigation
      if (type === 'external') {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
    }
  };

  return (
    <StyledAnchor
      ref={ref}
      href={href}
      onClick={handleClick}
      {...props}
    >
      {children}
    </StyledAnchor>
  );
});

NativeLink.displayName = 'NativeLink';

export default NativeLink;
